import EnumClass, { build } from '../EnumClass';
import data, { LanguageId, LanguageData } from './data';
import * as Translations from './translations';
import { tFunctionType } from 'app/services/localization';

export class Language extends EnumClass<LanguageId, LanguageData> {
  // If true, words in this language should prefer showing the value of the `transliteration` field
  // instead of the `pronunciation` field.
  public get preferTransliteration() {
    return this.metadata.ideographic;
  }

  public getName = Translations.name[this.id];
  public getNative = (t: tFunctionType) => {
    return this.getName(t, undefined, { locale: this.id });
  };

  public getSpokenName = (t: tFunctionType) => {
    if (this.id === 'zh-Hans' || this.id === 'zh-Hant') {
      return t('languages.spoken.chinese');
    } else {
      return this.getName(t);
    }
  };
}

export const {
  list: ALL_LANGUAGES,
  getById: getLanguageById,
  marshaller: LanguageMarshaller,
  isId: isLanguageId,
} = build<LanguageId, LanguageData, Language>('LanguageEnum', data, Language);
